<template>
  <div :class="classObj" class="app-wrapper" v-auto-height="60">
    <div id="watermark" style="background-image: var(--bg-img)" />
    <sidebar v-if="!hideSidebar" class="sidebar-container" :routes="routes"></sidebar>
    <div class="main-container">
      <breadcrumb v-if="!hideBreadcrumb"></breadcrumb>
      <transition name="fade" mode="out-in">
        <!-- <router-view :key="key"></router-view> -->
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/Sidebar/index'
import Breadcrumb from '@/components/Breadcrumb'
import { filterAuthRoutes, personAllRoutes, isAIPublish } from '@/router'
import aiPublishRoutes from '@/router/ai_publish'
import authService from '@/api/auth'
import commonService from '@/api/common'
// import ResizeMixin from './mixin/ResizeHandler'
var pkg = require('@/../package.json')

const Layout = {
  name: 'Layout',
  components: {
    Sidebar,
    Breadcrumb,
  },
  // mixins: [ResizeMixin],
  data() {
    return {
      retryTime: 3000,
      versionRetryTime: 60000,
    }
  },
  computed: {
    ...mapGetters([
      'company',
      'isAdmin'
    ]),
    routes() {
      let rts = isAIPublish ? aiPublishRoutes() : personAllRoutes
      if (this.isAdmin) {
        rts = personAllRoutes.concat(aiPublishRoutes())
      }
      return filterAuthRoutes(rts)
    },
    // sidebar() {
    //   return this.$store.state.app.sidebar
    // },
    // device() {
    //   return this.$store.state.app.device
    // },
    isCompany() {
      return !!this.$store.state.user.company
    },
    classObj() {
      return {
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        // mobile: this.device === 'mobile'
      }
    },
    hideSidebar() {
      const hideSidebar = this.$route.meta.hideSidebar
      return !!hideSidebar
    },

    hideBreadcrumb() {
      const hideBreadcrumb = this.$route.meta.hideBreadcrumb
      return !!hideBreadcrumb
    },
  },
  created() {
    // 能加载这个模块的都是已经登录的，把一些登录后才做的事情放这里。。。

    // 获取用户的原始版权公司列表
    this.fetchOriginCompany()

    // 请求版本信息
    this.fetchSystemVersion()
  },
  beforeDestroy() {
    // this.getOriginHandler
    this.getOriginHandler && clearTimeout(this.getOriginHandler)
    this.getVersionHandler && clearTimeout(this.getVersionHandler)
  },

  getOriginHandler: null,
  getVersionHandler: null,
  methods: {
    fetchOriginCompany() {
      if (!this.isCompany) return
      authService.queryOriginCompany().then(resp => {
        if (this.company && this.company.companyId) {
          const userCompany = this.company
          if (!resp.some(item => item.companyId === userCompany.companyId)) {
            // 原始版权公司列表还不包括账号的关联公司，则加进去
            resp.push({ companyId: userCompany.companyId, companyName: userCompany.companyName })
          }
        }
        this.$store.commit('SET_ORIGIN_COMPANY', resp)
        this.retryTime = 3000
      }).catch(error => {
        console.error(error)
        if (this.retryTime < 60000) { // 最大间隔 60 秒
          this.retryTime += 3000
        }
        this.getOriginHandler = setTimeout(_ => {
          this.fetchOriginCompany()
        }, this.retryTime) // 一直重试到成功
      })
    },

    async fetchSystemVersion() {
      try {
        const result = await commonService.getSystemVersion()

        if (result.appVersion !== pkg.version) {
          const h = this.$createElement

          this.$msgbox({
            title: '消息',
            type: 'warning',
            message: h('p', null, [
              '系统已更新，请刷新页面后操作'
            ]),
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showCancelButton: false,
            confirmButtonText: '刷 新',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                done()
              }
            }
          }).then(action => {
            location.reload()
          })
        } else {
          this.getVersionHandler = setTimeout(_ => {
            this.fetchSystemVersion()
          }, this.versionRetryTime)
        }
      } catch (error) {
        console.error(error)
        console.log(pkg.version)

        this.getVersionHandler = setTimeout(_ => {
          this.fetchSystemVersion()
        }, this.versionRetryTime) // 一直重试到成功
      }
    }
  }
}
export default Layout

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.drawer-bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  z-index: 999;
  background: #000;
}
#watermark {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 9;
  opacity: 0.25;
}
</style>
